// Promotional badges shown in the corner of a listing: a preset, or a custom line written by hand.
export const BADGE_PRESETS = {
  new_farm: { tr: "Yeni Çiftlik", en: "New Farm", ar: "مزرعة جديدة" },
  opportunity: { tr: "Fırsat Çiftlik", en: "Opportunity Farm", ar: "مزرعة بفرصة مميزة" },
  great_location: { tr: "Muhteşem Konumda", en: "Superb Location", ar: "موقع رائع" },
  last_parcels: { tr: "Son Parseller", en: "Last Parcels", ar: "آخر القطع" },
};
export const BADGE_KEYS = Object.keys(BADGE_PRESETS);

const today = () => new Date().toISOString().slice(0, 10);

// Null when there is no badge or its end date has passed.
export const activeBadge = (badge) => {
  if (!badge || !badge.key) return null;
  if (badge.until && badge.until < today()) return null;
  return badge;
};

export const badgeText = (badge, lang = "tr") => {
  const b = activeBadge(badge);
  if (!b) return "";
  if (b.key === "custom") {
    const t = b.text || {};
    return t[lang] || t.tr || t.en || t.ar || "";
  }
  const p = BADGE_PRESETS[b.key];
  return p ? p[lang] || p.tr : "";
};
